export default "__VITE_ASSET__3OEU9Mb5__"